import React from 'react'
import CloudSubNav from '../components/CloudSubNav'
import MobileAppFeatureCard from './components/MobileAppFeatureCard'
import MobileAppLogoUpload from './components/MobileAppLogoUpload'
import MobileAppTipsCard from './components/MobileAppTipsCard'
import AppFormFooterBar from '../../../components/AppFormFooterBar'
import useMobileApp from './hooks/useMobileApp'

export default function MobileAppScreen() {
  const { state, actions } = useMobileApp()
  const { settings, isSaving, communicationFeatures, academicFeatures, analyticsFeatures } = state

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-28">
      {/* ── Top Canopy: Header & SubNav ── */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">
            Cloud &amp; Digital Platforms
          </p>
          <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-on-surface">
            Mobile App Configuration
          </h1>
          <p className="mt-0.5 text-xs text-on-surface-variant">
            Configure feature availability, branding logo, and subscription options for student &amp; parent mobile applications.
          </p>
        </div>

      </section>

      {/* ── Main 2-Column Grid ── */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 items-start">
        {/* ── Left Column: 3 Feature Category Cards (8 cols) ── */}
        <div className="lg:col-span-8 flex flex-col gap-6">
          {/* Card 1: Communication & Attendance */}
          <MobileAppFeatureCard
            title="Communication & Attendance"
            icon="forum"
            badge="Core Modules"
            features={communicationFeatures}
            values={settings}
            onToggle={actions.handleToggle}
          />

          {/* Card 2: Academic Operations & Fees */}
          <MobileAppFeatureCard
            title="Academic Operations & Fees"
            icon="school"
            badge="Academic Suite"
            features={academicFeatures}
            values={settings}
            onToggle={actions.handleToggle}
          />

          {/* Card 3: Visual Performance Analytics */}
          <MobileAppFeatureCard
            title="Student Analytics & Visual Graphs"
            icon="analytics"
            badge="Insights"
            features={analyticsFeatures}
            values={settings}
            onToggle={actions.handleToggle}
          />
        </div>

        {/* ── Right Column: Logo Upload & Tips Card (4 cols) ── */}
        <div className="lg:col-span-4 flex flex-col gap-6 sticky top-6">
          <MobileAppLogoUpload
            logoUrl={settings.logoUrl}
            onLogoChange={actions.handleLogoChange}
          />

          <MobileAppTipsCard
            appValidTill={settings.appValidTill}
            notificationBalance={settings.notificationBalance}
            isExpired={settings.isExpired}
          />
        </div>
      </div>

      {/* ── Bottom Fixed Save Bar ── */}
      <AppFormFooterBar
        onSave={actions.handleSave}
        onCancel={actions.handleReset}
        isSaving={isSaving}
        saveText="Save Settings"
        cancelText="Reset to Defaults"
      />
    </div>
  )
}
